"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Context = React.createContext(null);
exports.DashboardContext = Context;
//# sourceMappingURL=DashboardContext.js.map